import Vue from "vue";
import timestampFormat from './timestamp-format';

Vue.use(timestampFormat);
